module.exports = __webpack_public_path__ + "static/img/44.8bc4c1fe.png";